<template>
    <va-create-layout>
        <RefundEventShipmentItemTaxWithheldCharge-form
            :title="title"
            :item="item"
        ></RefundEventShipmentItemTaxWithheldCharge-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
